var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon__x2F___Close"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    fill: "#8E97A3",
    d: "M12,13.4l4.3,4.3c0.2,0.2,0.4,0.3,0.7,0.3c0.3,0,0.5-0.1,0.7-0.3c0.2-0.2,0.3-0.4,0.3-0.7       c0-0.3-0.1-0.5-0.3-0.7L13.4,12l4.3-4.3C17.9,7.5,18,7.3,18,7c0-0.3-0.1-0.5-0.3-0.7C17.5,6.1,17.3,6,17,6c-0.3,0-0.5,0.1-0.7,0.3       L12,10.6L7.7,6.3C7.6,6.2,7.5,6.1,7.4,6.1C7.3,6,7.1,6,7,6S6.7,6,6.6,6.1C6.5,6.1,6.4,6.2,6.3,6.3C6.2,6.4,6.1,6.5,6.1,6.6       C6,6.7,6,6.9,6,7c0,0.1,0,0.3,0.1,0.4c0.1,0.1,0.1,0.2,0.2,0.3l4.3,4.3l-4.3,4.3c-0.1,0.1-0.2,0.2-0.2,0.3C6,16.7,6,16.9,6,17       c0,0.1,0,0.3,0.1,0.4c0.1,0.1,0.1,0.2,0.2,0.3c0.1,0.1,0.2,0.2,0.3,0.2C6.7,18,6.9,18,7,18s0.3,0,0.4-0.1c0.1-0.1,0.2-0.1,0.3-0.2       L12,13.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.2285a47f40a8dd9aa8123a8c158593b0.svg";
export { ForwardRef as ReactComponent };